import React from "react";

/**
 * props:
 * - images: [{id, src, title, date}]
 * - activeId
 * - onSelect(id)
 */
const ThumbnailList = ({ images = [], activeId, origid, onSelect = () => {} }) => {

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
  };

  return (
    <div className="thumb-list" aria-label="Image thumbnails">
      {images.map((img) => (
        <div
          key={img.id}
          role="button"
          tabIndex={0}
          data-id={img.id}
          /* onClick={() => onSelect(img.id)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onSelect(img.id);
            }
          }} */
          className={`thumb-item ${activeId === img.id ? "active" : ""}`}
        >
          <a href={`${process.env.REACT_APP_BASENAME}photographer-view-feedback/${img.photoshoot_id}/${origid}/${img.fname}`}>
            <img className="thumb-img" src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${img.fname}`} alt={img.title} />
            <div className="thumb-meta">
              <div className="thumb-date">{formatDate(img.created_at)}</div>
            </div>
          </a>
        </div>
      ))}
    </div>
  );
};

export default ThumbnailList;
